import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../store/index";
import * as services from "../../../store/service";
import * as CSIDActions from "../../../store/csid/actions";
import { useForm } from "react-hook-form";
import { IAddress } from "../../../store/csid/types";
import { PATTERNS } from "../../../util/patterns";
interface IProps {
    closeButtonText: string;
    onCloseCallback: any;
    openAsDialog: boolean;
    submitButtonText: string;
    onSubmitCallback: any;
    errorCallback: any;
    telephone?: string;
    ssn: string;
    dob?: string;
    address?: IAddress;
    postponeActivation: boolean;
    tuTrustedSessionId?: string;
    questionOption: IL3QuestionOption;
    selectedOTPOptionText: string;
    maxTryCount: number; // intial = 3
}

interface IL3Question {
    "question-id": string;
    "question-text": string;
    options: IL3Option[];
}

interface IDFL3QuestionDTO {
    "auth-status": string;
    "status-code": string;
    message: string;
    questions: IL3Question[];
}

interface IL3Option {
    "option-id": string;
    "option-text": string;
}

interface IL3QuestionOption {
    "question-id": string;
    "option-id": string;
}

interface IL3QuestionOptionOTPInput extends IL3QuestionOption {
    "user-input-answer": string;
}

const L3OTPVerificationComponent: React.FunctionComponent<IProps> = (props) => {
    const status = {
        success: "success",
        error: "error",
        systemError: "system-error",
        l3LastTryFail: "l3-last-try-fail",
        l3LastTryTimemout: "l3-timeout-locked",
        l3AttemptFail: "l3-attempt-fail",
        l3Timeout: "l3-timeout",
        thinClient: "thin-client",
        manualAuthentication: "manual-authentication",
        locked: "locked",
        l3OtpLocked : "l3-otp-locked",
        inProgress: "in-progress",
        invalidSsn: "invalid-ssn",
        noQuestion: "no-question",
        lockedNotEnoughInfo: "locked-not-enough-info",
    };

    // const { isSubmitting } = formState;
    const [isLoading, setIsLoading] = useState(false);
    const [passCodeMismatch, setPassCodeMismatch] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const dispatch = useDispatch();

    const [userInputCode, setUserInputCode] = useState("");
    const isTUUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userInfo?.isTUUser);
    const initialQuestions = [
        {
            "question-id": "",
            "question-text": "",
            options: [
                {
                    "option-id": "",
                    "option-text": "",
                },
            ],
        },
    ];

    const [questions, setQuestions] = useState(initialQuestions);

    const globalTUOTPTryCount = useSelector((state: ApplicationState) => {
        if (state.csidUserStatusState) {
            return state.csidUserStatusState?.globalTUOTPTryCount;
        }

        return 0;
    });

    const globalTUOTPRequestedCount = useSelector((state: ApplicationState) => {
        if (state.csidUserStatusState) {
            return state.csidUserStatusState?.globalTUOTPRequestedCount;
        }

        return 0;
    });

    const setGlobalTUOTPTryCount = (tryCount: number) => dispatch(CSIDActions.actionCreators.setGlobalTUOTPTryCount(tryCount));

    const setGlobalTUOTPRequestedCount = (requestCount: number) => dispatch(CSIDActions.actionCreators.setGlobalTUOTPRequestedCount(requestCount));

    let strCloseButtonText = "Close";
    let blnOpenAsDialog = false;

    // set default value for props, if not passed
    if (props.closeButtonText != null) {
        strCloseButtonText = props.closeButtonText;
    }

    if (props.openAsDialog != null) {
        blnOpenAsDialog = props.openAsDialog;
    }

    const sendOTPCodeForSelectedOption = () => {
        setIsLoading(true);
        let answer: IL3QuestionOption = props.questionOption as IL3QuestionOption;
        let answers = [answer];

        services
            .verifyOTPAuthentication(answers, props.postponeActivation, props.ssn, props.dob, props.address, props.tuTrustedSessionId)
            .then((data) => {
                setIsLoading(false);

                var responseObj: any = {};
                try {
                    responseObj = JSON.parse(data);
                } catch (e) {
                    responseObj = data;
                }

                var providerResponse: IDFL3QuestionDTO;
                providerResponse = responseObj.providerResponse as IDFL3QuestionDTO;
                if (providerResponse["auth-status"] != null) {
                    let questions = providerResponse.questions;
                    setQuestions(questions);
                }
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    const ensureDataFetchedOnLoad = () => {
        sendOTPCodeForSelectedOption();
    };

    useEffect(ensureDataFetchedOnLoad, []);

    const getAnswerForOTPOption = function (questions: IL3Question[], userInputCode: string): IL3QuestionOptionOTPInput {
        let questionId = "";
        let optionId = "";
        if (questions && questions.length > 0) {
            let questionObj: IL3Question = questions[0];

            questionId = questionObj["question-id"];
            let optionSelected: any = null;
            for (let i = 0; i < questionObj.options.length; i++) {
                optionSelected = questionObj.options[i];
            }
            optionId = optionSelected["option-id"];
        }

        return {
            "question-id": questionId,
            "option-id": optionId,
            "user-input-answer": userInputCode,
        };
    };

    const onSendNewOTPCode = () => {
        setIsLoading(true);
        services
            .sendNewTUOTPCode(props.selectedOTPOptionText, props.ssn, props.postponeActivation, props.dob, props.address, props.telephone, props.tuTrustedSessionId)
            .then((data) => {
                setIsLoading(false);

                var responseObj: any;
                try {
                    responseObj = JSON.parse(data);
                } catch (e) {
                    responseObj = data;
                }

                var providerResponse: IDFL3QuestionDTO;
                providerResponse = responseObj.providerResponse as IDFL3QuestionDTO;
                if (providerResponse["auth-status"] != null) {
                    let questions = providerResponse.questions;
                    setQuestions(questions);

                    const numberOfAttempts = responseObj.providerResponse["number-of-attempts"];
                    setGlobalTUOTPRequestedCount(numberOfAttempts);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                invokePostSubmitCallback(status.error, { reason: status.systemError, detail: error });
            });

        return false;
    };

    const onSubmitOTPCode = (data: any) => {
       if (userInputCode) {
        clearErrors();
        submitInputAnswer(userInputCode);
    }
      setSubmitted(true);
    };

    const submitInputAnswer = function (userInputCode: string) {
        if (!userInputCode) {
            return;
        }
        setPassCodeMismatch(false);

        let answer: IL3QuestionOption = getAnswerForOTPOption(questions, userInputCode);
        setIsLoading(true);
        setGlobalTUOTPTryCount(globalTUOTPTryCount + 1);
        services
            .verifyOTPAuthentication([answer], props.postponeActivation, props.ssn, props.dob, props.address, props.tuTrustedSessionId)
            .then((data) => {
                setIsLoading(false);
                 var responseObj: any = {};
                try {
                    responseObj = JSON.parse(data);
                } catch (e) {
                    responseObj = data;
                }

                var providerResponse: IDFL3QuestionDTO;
                providerResponse = responseObj.providerResponse as IDFL3QuestionDTO;

                if (providerResponse["auth-status"] != null) {
                   
                const authStatus = providerResponse["auth-status"].toUpperCase().trim().replace(/[-]/g,"");
                 switch (authStatus) {
                        case "AUTHENTICATED":
                            invokePostSubmitCallback(status.success, { detail: responseObj });
                            break;
                        case "LOCKED":
                            invokePostSubmitCallback(status.locked, { reason: status.locked, detail: responseObj });
                            break;
                        case "L3OTPLOCKED":
                            invokePostSubmitCallback(status.l3OtpLocked, { reason: status.l3OtpLocked, detail: responseObj });
                            break;
                        case "IN PROGRESS":
                            if (providerResponse.questions != null) {
                                let questions = providerResponse.questions;
                                setQuestions(questions);
                                setPassCodeMismatch(true);
                            } else {
                                invokePostSubmitCallback(status.inProgress, { detail: responseObj, tryCount: globalTUOTPTryCount });
                            }
                            break;
                        default:
                            invokePostSubmitCallback(status.error, { reason: status.systemError, detail: responseObj, tryCount: globalTUOTPTryCount });
                             break;
                            
                    }
                } else {
                    invokePostSubmitCallback(status.error, { reason: status.systemError, detail: responseObj, tryCount: globalTUOTPTryCount });
                }
            })
            .catch((error) => {
                setIsLoading(false);
                invokePostSubmitCallback(status.error, { reason: status.systemError, detail: error });
            });
    };

    const invokePostSubmitCallback = (status: string, data: any) => {
        if (props.onSubmitCallback != null) {
            props.onSubmitCallback({ status: status, data: data });
        }
    };

    // handle close button click
    // add reason, so that the callback function can identify, if it's cancel (incase of dialog: ESC press) or button click close
    const onClose = (reason?: string) => {
        // execute method passed as props for onCloseButtonClick
        if (props.onCloseCallback != null) {
            props.onCloseCallback({ reason: reason == null ? "close" : "cancel" });
        }
    };

    // in case of dialog, register event for escape press
    if (blnOpenAsDialog) {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                window.removeEventListener("keyup", () => {});
                onClose("cancel");
            }
        });
    }

    const { register, handleSubmit, errors, clearErrors } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    return (
        <React.Fragment>
            <div className={`${isLoading && "loading"}`}>
                <div className="dialog-header otp-dialog-header">
                    {props.openAsDialog && (
                        <div className="dialog-icon status-default">
                            <em className="las la-user-shield"></em>
                        </div>
                    )}
                    <h1>Verify your Identity</h1>
                </div>

                <div className="dialog-body otp-dialog-body large-dialog-scroll">
                    <form id="form-submit-otp-code" onSubmit={handleSubmit(onSubmitOTPCode)}>
                        <p>
                            <strong>Please enter the 5-digit passcode sent to the mobile number you provided in your application.</strong>
                        </p>
                        <p>
                            {globalTUOTPRequestedCount > 1 && <span>Please check your phone for the new passcode, the previous passcode is no longer valid.</span>}
                            <span> The passcode is valid for 15 minutes and you have 3 chances to enter it correctly.</span>
                        </p>

                        <div className="form-row inline row">
                            <div className={`form-input ${errors["otp-code"] && "status-error"}`}>
                                <div className="form-label">
                                    <label htmlFor="otp-code-label">Enter 5 Digit Code</label>
                                </div>
                                <input
                                    type="tel"
                                    id="otp-code-label"
                                    className="inputbox"
                                    autoComplete="off"
                                    maxLength={5}
                                    defaultValue=""
                                    name="otp-code"
                                    ref={register({
                                        required: true,
                                        maxLength: 5,
                                        pattern: PATTERNS.TUOTP.pattern,
                                    })}
                                    onChange={ (e) => {
                                          setUserInputCode(e.currentTarget.value);
                                          setSubmitted(false);
                                         
                                     }
                                    }
                                />
                                {errors["otp-code"] && (errors["otp-code"].type === "pattern" || errors["otp-code"].type === "minLength") && (
                                    <span className="form-error">One time passcode can only include numbers and must be 5 digits in length.</span>
                                )}
                                {passCodeMismatch && <span className="form-error">Please reenter, passcode does not match.</span>}
                                {passCodeMismatch && (
                                    <span className="form-error">
                                        Attempt {globalTUOTPTryCount} of {props.maxTryCount}.
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="col-xs-12 otp-button-container">
                            {globalTUOTPRequestedCount < props.maxTryCount && (
                                <a className="default_link otp-send-new-link" href="javascript:void(0)" onClick={() => onSendNewOTPCode()}>
                                    Send a New Code
                                </a>
                            )}
                            <button type="submit" disabled={userInputCode.length !== 5} className="btn-default btn-primary btn-min-width otp-button">
                                <span className="btn-text">Verify My Identity</span>
                            </button>
                        </div>
                    </form>
                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                              {!isTUUser &&(<button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => onClose()}>
                                    <span className="btn-text">{strCloseButtonText}</span>
                                </button>)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default L3OTPVerificationComponent;
